operations:
  load-models: Cargar Modelos
  load-models-status:
    loading: Cargando
    ready: Listo
docs:
  theme:
    navbar:
      appearance:
        title: Apariencia
'controls-island':
  'fade-on-hover':
    enable: Ocultar al pasar el cursor
    disable: Mostrar siempre
  'open-settings': Abrir configuración
  'open-chat': Abrir Chat
  'refresh': Actualizar
  'open-hearing-controls': Abrir controles de audición
  'drag-to-move-window': Arrastra para mover la ventana
  'switch-to-light-mode': Cambiar a modo claro
  'switch-to-dark-mode': Cambiar a modo oscuro
  'pin-on-top': Anclar Arriba
  'unpin-from-top': Desanclar de la parte superior
  'switch-profile': Cambiar Perfil
  'close': Cerrar
  'expand': Expandir
  'collapse': Contraer
  'login': Sign in
  'logging-in': Signing in...
  'account': Account
  'logout': Sign out
widgets:
  close: Close widget
  empty:
    title: No widget active
    description: Widgets will appear here when a tool or plugin spawns one.
  loading: Loading widget…
  waiting: Waiting for widget data for "{id}"…
notice:
  'fade-on-hover':
    title: Desvanecer al pasar el cursor
    intro: Difumina el personaje automáticamente cuando el cursor está cerca. Reduce distracciones sin perder visibilidad.
    opacity: Al activarlo, la opacidad baja a {value} para {targets} cuando el cursor está cerca.
    toggle: Puedes desactivarlo pasando el cursor por {controls} y tocando de nuevo el {icon}.
    controls-label: Isla de controles
    icon-label: ícono de ojo tachado
    value: '0'
    targets: Personaje y UI
    confirm: Entendido
    dont-show-again: No volver a mostrar
    preparing: Preparando…
    read-more: Leer más
    preview-title: '¿Qué es esto?'
about:
  subtitle: Desktop ver.
  current-version: Current Version
  common:
    cancel: Cancel
  links:
    title: Links
    home: Home
    documentation: Documentations
    github: GitHub
  update:
    lane:
      label: Update lane
      description: Choose channel release to follow
      placeholder: Choose update lane
    channels:
      auto: Auto
      stable: Stable
      alpha: Alpha
      beta: Beta
      nightly: Nightly
      canary: Canary
    status:
      downloading: Downloading update...
      error-prefix: Error
      latest: Up to date (v{version}).
      downloaded:
        windows: Update ready to install silently (v{version}).
        restart: Update ready to install on restart (v{version}).
    actions:
      download: Download Update
      download-short: Download
      confirm-download: Confirm Download
      check-for-updates: Check for updates
      checking: Checking...
      latest-version: Latest version
      disabled-dev: Updates disabled in Dev
      retry-check: Retry Check
      restart-silent: Restart to update silently
      restart-install: Restart to install update
      confirm-restart: Confirm Restart
    dialog:
      title: Update Available
      description: A new version (v{version}) is available.
      no-release-notes-markdown: _No release notes provided._
